import React, { useEffect, useState } from "react";
import { Button, Col, Form, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { createCompany, updateCompany } from "../services/companyApi";
import { useQueryClient } from "react-query";
import toast from "react-hot-toast";
import { Spin } from "antd";
import { AppstoreAddOutlined } from "@ant-design/icons";
import "../utils/style.css"
import FormField from "../../../common/Form/FormField";

const AddEditCompanyForm = ({ modal, setModal, toggle, selectedCompany, currentuser }) => {
  
  const queryClient = useQueryClient();
  const [isLoadingSubmit, setisLoadingSubmit] = useState(false);

  const merchantId = currentuser?.user?.id;
  const companyId = selectedCompany?.id;
  
  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Oups!!! Veuillez renseigner le nom"),
  });

  const initialValues = selectedCompany ? {
    name: selectedCompany.name,
  } : {
    name: "",
    merchantId: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setisLoadingSubmit(true);
      try {
        const payload = {
          name: values.name,
        };
        
        if (selectedCompany) {
          await updateCompany(merchantId,companyId,payload);
          toast.success("L'entreprise a été modifiée avec succès 🎉");
        } else {
          await createCompany(merchantId, payload);
          toast.success("L'entreprise a été créée avec succès 🎉");
        }
        
        await queryClient.invalidateQueries("companies");
        toggle();
        formik.resetForm();
      } catch (error) {
        if (selectedCompany) {
          console.error("Erreur modification entreprise :", error?.message || error);
          toast.error("😌 Erreur lors de la modification de l'entreprise :", error?.message || error);
        } else {
          console.error("Erreur lors de l'ajout de l'entreprise :", error?.message || error);
          toast.error("😌 Erreur lors de l'ajout de l'entreprise :", error?.message || error);
        }
      }
      finally {
        setisLoadingSubmit(false);
      }
    },
  });

  useEffect(() => {
    formik.setValues(initialValues);
  }, [selectedCompany]);

  const modalTitle = selectedCompany ? "Édition" : `Ajout`;

  return (
    <Modal
      id="showModalClient"
      isOpen={modal}
      toggle={toggle}
      centered
      backdrop={"static"}
      style={{ maxWidth: "700px" }}
    >
      <ModalHeader className="active-tab p-3" toggle={toggle}>
        {modalTitle} de mon entreprise <AppstoreAddOutlined />
      </ModalHeader>
      <Form onSubmit={formik.handleSubmit}>
        <ModalBody>
          <Row>
            <FormField label="Nom entreprise" name="name" formik={formik} colSize={6} placeholder="Donnes moi juste le nom et je vous créé votre entreprise"/>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="light" onClick={() => setModal(false)}>
            Annuler
          </Button>
          <Button type="submit" className="active-tab" disabled={isLoadingSubmit}>
            {isLoadingSubmit ? <Spin size="small" text="En cours" /> : (selectedCompany ? "Modifier" : "Ajouter")}
          </Button>
        </ModalFooter>
      </Form>
    </Modal>
  );
};

export default AddEditCompanyForm;
